// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** New Zealand */
const NZ = /^(?:2(?:[0-27-9]\d|6)\d{6,7}|2(?:1\d|75)\d{5})$/;

export default NZ;
